type NoFilesPlaceholderProps = {
  text: string
}

export function NoFilesPlaceholder({ text }: NoFilesPlaceholderProps) {
  return (
    <div className="flex items-center justify-center text-gray-500 text-lg font-medium" data-testid="documents-empty-state">
      {text}
    </div>
  )
}
